module.exports = __webpack_public_path__ + "static/mobile-desk-abca4b0136382fec9abc201bf49ebea9.png";